import { render, staticRenderFns } from "./SingleEvent.vue?vue&type=template&id=305d12d7&scoped=true&"
import script from "./SingleEvent.vue?vue&type=script&lang=js&"
export * from "./SingleEvent.vue?vue&type=script&lang=js&"
import style0 from "./SingleEvent.vue?vue&type=style&index=0&id=305d12d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305d12d7",
  null
  
)

export default component.exports